import { ExtendedLineItem } from 'shared/types/cart/LineItem';

export const calculateSubtotalAmount = (lineItems?: ExtendedLineItem[]) => {
  return (lineItems ?? []).reduce((acc, curr) => {
    if (curr.isGift) {
      return acc;
    }

    return (
      acc +
      (curr.price?.centAmount || 0) * (curr.count as number) -
      (curr.taxRate?.includedInPrice ? curr.taxed?.taxAmount?.centAmount || 0 : 0)
    );
  }, 0);
};
